import { Link } from "react-router-dom";
import { FOOTER_LINKS } from "../data";
import { ASSETS, X_URL, BUY_URL, CHART_URL } from "../config";
import { XIcon } from "./SocialIcons";
import { CopyCA } from "./CopyCA";
import { Label, StatusDot } from "./primitives";

export const Footer = () => (
  <footer className="border-t border-white/[0.08] bg-ink-850" data-testid="footer">
    <div className="mx-auto max-w-[1440px] px-5 py-14 md:px-8">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="SYNAPTIX" className="h-9 w-9 object-contain" />
            <span className="font-display text-base font-bold tracking-[0.3em] text-fog-100">SYNAPTIX</span>
          </div>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-brass">
            The Neural Layer for Autonomous Finance
          </p>
          <div className="mt-6 flex items-center gap-2">
            <StatusDot />
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog-600">System Online — Robinhood Chain Ecosystem</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <Label className="mb-4">Navigation</Label>
          <div className="grid grid-cols-2 gap-x-4">
            {FOOTER_LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="py-1.5 text-sm text-fog-400 transition-colors hover:text-fog-100">
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <Label className="mb-4">Social</Label>
          <div className="flex flex-col gap-2.5">
            <a href={X_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-social-x"
              className="flex items-center gap-2.5 text-sm text-fog-400 transition-colors hover:text-fog-100">
              <XIcon className="h-3.5 w-3.5" /> X / Twitter
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <Label className="mb-4">Token</Label>
          <div className="flex flex-col gap-2.5 font-mono text-[11px] uppercase tracking-[0.15em]">
            <CopyCA testId="footer-copy-ca" />
            <a href={BUY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-buy"
              className="flex justify-between gap-3 text-fog-400 transition-colors hover:text-pulse-soft">
              <span className="text-fog-600">Buy</span><span>PONSFAMILY.COM</span>
            </a>
            <a href={CHART_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-chart"
              className="flex justify-between gap-3 text-fog-400 transition-colors hover:text-pulse-soft">
              <span className="text-fog-600">Chart</span><span>DEXTools</span>
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 border-t border-white/[0.06] pt-6">
        <p className="max-w-3xl text-[11px] leading-relaxed text-fog-600" data-testid="footer-disclaimer">
          SYNAPTIX is an experimental autonomous finance infrastructure project. Nothing on this website constitutes
          financial advice. Features marked as simulation or coming soon are not live financial services.
        </p>
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-fog-600">
          © 2026 SYNAPTIX — Built for the Robinhood Chain ecosystem
        </p>
      </div>
    </div>
  </footer>
);
